import classNames from 'classnames'
import { useCallback } from 'react'
import styles from './Badge.module.scss'
import { BadgeSize, BadgeStyle } from './types'
import type { BadgeProps } from '.'

const Badge = ({
  style = BadgeStyle.neutral,
  size = BadgeSize.medium,
  surfaceColor,
  value,
  className,
}: BadgeProps) => {
  const parseValue = useCallback(() => {
    if (size === BadgeSize.xsmall) return null

    if (value && value > 99) return '99+'
    return value
  }, [size, value])
  return (
    <div
      className={classNames(styles['pintxo-badge'], className)}
      data-style={style}
      data-size={size}
      data-surfacecolor={surfaceColor && surfaceColor}
    >
      <div className={styles['pintxo-badge-wrapper__badge__value']}>{parseValue()}</div>
    </div>
  )
}
export default Badge
